import { getAllExercises, getRecentExercises, getExercisesByType } from './exercisesRequestConfigs';

class ExercisesApi {
    getAllExercises = getAllExercises;
    getRecentExercises = getRecentExercises;
    getExercisesByType = getExercisesByType;
}

class ExercisesFactory {
    exercises = ExercisesApi;
    create() {
        return new this.exercises();
    }
}

export const exercises = new ExercisesFactory();



// WEBPACK FOOTER //
// ./src/BusinessLogic/Network/API/ExercisesApi/index.js